import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import * as Icon from 'react-feather';
import { MAX_CONVOCATORIAS_BASE } from '../../../helpers/convocatorias';

// Columnas 6ª y 7ª solo si alguna UF del ciclo admite más de 5 convocatorias
// (LOE-2122) o ya tiene más de 5 notas. `actividades` trae además objetos que no
// son UF (histórico), por eso el acceso es defensivo.
const tieneConvocatoriasExtra = (modulos) =>
  modulos.some((modulo) =>
    (modulo.actividades || []).some(
      (a) =>
        Number(a?.maxConvocatorias) > MAX_CONVOCATORIAS_BASE ||
        (Array.isArray(a?.notasConvocatorias) &&
          a.notasConvocatorias.length > MAX_CONVOCATORIAS_BASE),
    ),
  );

function TablaModulos({ isOpen, modulos }) {
  const extra = tieneConvocatoriasExtra(modulos);
  return (
    <div className="border px-2 py-2" style={{ display: isOpen ? 'block' : 'none' }}>
      <Table borderless>
        <thead>
          <tr>
            <th className="text-center">Nombre</th>
            <th className="text-center">Matriculado</th>
            <th className="text-center">Horas</th>
            <th className="text-center">Primera convocatoria</th>
            <th className="text-center">Segunda convocatoria</th>
            <th className="text-center">Tercera convocatoria</th>
            <th className="text-center">Cuarta convocatoria</th>
            <th className="text-center">Gracia</th>
            {extra && <th className="text-center">Sexta convocatoria</th>}
            {extra && <th className="text-center">Séptima convocatoria</th>}
            <th className="text-center">Nota</th>
          </tr>
        </thead>
        <tbody>
          {modulos.map((modulo, index) => (
            <React.Fragment key={`${modulo.codigo}-${index}`}>
              <tr
                style={{ backgroundColor: '#eef5f9' }}
                className="border-bottom"
                key={`mod-${modulo.codigo}-${index}`}
              >
                <td>
                  <span style={{ fontWeight: 'bold' }}>{modulo.nombre}</span>
                </td>
                <td className="text-center">
                  {modulo.completado === false ? '-' : <Icon.Check size={20} />}
                </td>
                <td className="text-center">{modulo.horas}</td>
                <td />
                <td />
                <td />
                <td />
                <td />
                {extra && <td />}
                {extra && <td />}
                <td className="text-center">{modulo.nota}</td>
              </tr>
              {modulo.actividades.map((actividad) => (
                <tr key={actividad.codigo}>
                  <td style={{ paddingLeft: '20px' }}>{actividad.nombre}</td>
                  <td className="text-center">
                    {actividad.matriculada ? <Icon.Check size={20} /> : ''}
                  </td>
                  <td className="text-center">{actividad.horas}</td>
                  <td className="text-center">{actividad.notaConvocatoria1}</td>
                  <td className="text-center">{actividad.notaConvocatoria2}</td>
                  <td className="text-center">{actividad.notaConvocatoria3}</td>
                  <td className="text-center">{actividad.notaConvocatoria4}</td>
                  <td className="text-center">{actividad.notaConvocatoriaGracia}</td>
                  {extra && <td className="text-center">{actividad.notaConvocatoria6}</td>}
                  {extra && <td className="text-center">{actividad.notaConvocatoria7}</td>}
                  <td className="text-center">{actividad.nota}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

TablaModulos.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  modulos: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string,
      nombre: PropTypes.string,
      completado: PropTypes.bool,
      horas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      actividades: PropTypes.arrayOf(
        PropTypes.shape({
          codigo: PropTypes.string,
          nombre: PropTypes.string,
          matriculada: PropTypes.bool,
          horas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria3: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria4: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoriaGracia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria6: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notaConvocatoria7: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          notasConvocatorias: PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          ),
          maxConvocatorias: PropTypes.number,
          nota: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    }),
  ).isRequired,
};

export default TablaModulos;
